import { useEffect, useRef } from 'react';

export function usePaymentPolling({ refetch, enabled, interval = 2000 }) {
    const timerRef = useRef();

    useEffect(() => {
        if (!enabled) {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
            return;
        }
        timerRef.current = setInterval(() => {
            refetch();
        }, interval);
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [enabled, interval, refetch]);
}
